<!--
 * @Author: QWX
 * @Description:对账结算变更记录弹窗
 * @LastEditors: QWX
 * @LastEditTime: 2021-11-09 10:43:48
-->
<template>
  <zl-dialog class="zl-saas" ref="dialog" title="对账结算变更记录" width="870px">
    <el-table :data="tableData">
      <el-table-column label="序号" type="index" width="80px"></el-table-column>
      <el-table-column label="对账金额" prop="">
        <template slot-scope="{row}">
          <p v-for="item in JSON.parse(row.accountMoney || '[]')" :key="item.currency">
            {{item.currencyCh}}：{{item.money | $zlFiltersMoneyFormat}}
          </p>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" prop="createTime" :formatter="(row) => dayjs(row.createTime).format('YYYY-MM-DD hh:mm:ss')"></el-table-column>
      <el-table-column label="操作" >
        <template slot-scope="{row}">
          <el-link type="primary" @click="goDetail(row)">查看</el-link>
        </template>
      </el-table-column>
    </el-table>
  </zl-dialog>
</template>

<script>
import store from '@/store'
import dayjs from 'dayjs'
export default {
  data() {
    return {
      dayjs,
      tableData: []
    }
  },
  methods: {
    open(itemId) {
      this._getList(itemId)
      return this.$refs.dialog.open()
    },
    _getList(itemId) {
      store.dispatch(store.state.system === 'purchaser' ? 'listAccountLS' : 'listAccountLSGys', { itemId }).then(res => {
        this.tableData = res
      })
    },
    /**
     * @description: 跳转详情
     * @param {*} row
     * @return {*}
     */
    goDetail(row) {
      this.$refs.dialog.close(row.id)
    }
  }
}
</script>
